const selector = ".collection";
let cacheManager = {};

window.addEventListener('pageshow', function(e){
  onLoad(e);
});

function onLoad(e){
  cacheManager = new PageCacheManager(
    { 
      bodySelector: selector,
      onLoaded: onLoadedCache,
      onCached: onCachedCache,
    }
  );
  
  if(!e.persisted)
  {
    document.addEventListener('click',function(e){
      const closest = e.target.closest('#main-collection-product-grid .card-wrapper');
      if(closest) cacheManager.cachePage();
    });
  }
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '#main-collection-product-grid',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    loadingText: '',
    offset: 1000,
    callback: callback
  });
}

function callback(){
  console.log('EXIT');
}

function onLoadedCache(e){
  console.log('loaded');
  infiniteScrollCollection();
  document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e){
  console.log('cached');
};